import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import CategoryScreen from '../../../components/categoryScreen';
import CategoryScreenBG from '../../../images/ComponentImages/categoryScreenBackground.png';
import CourseDescriptionV2Image from '../../../images/CCMRS/CCMRCourseDescriptionV201.png';
import CourseDescriptionV2 from '../../../components/courseDescriptionV2';
import ItemGrid from '../../../components/itemGrid';
import WarningBlock from '../../../components/warningBlock';

export default function Page21({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<CategoryScreen
				titles={['DAY 6', 'RECOVERY DAY']}
				texts={['Cardio', 'Eat', 'Vision']}
				BGImage={CategoryScreenBG}
			/>
			<CourseDescriptionV2
				mt={true}
				title='CARDIO'
				bgImage={CourseDescriptionV2Image}
				texts={[
					'Incline TreadMill: 45min - 1hour',
					'Reason of Cardio',
					"You need to do cardio even if it's just a light workout session, it's great for you. Cardio is important during your recovery days because it increases blood flow throughout your body which helps muscle damage heal quicker. This helps the body build muscle back up quicker and helps push out waste and lactic acid.",
				]}
			/>
			<WarningBlock
				texts={[
					'Below is an example of a meal plan. Each Client varies. Each client’s body vaies. For custom food plans contact brugmethod@gmail.com to fit your needs. Thank you.',
				]}
				mt={true}
			/>
			<ItemGrid
				mt={true}
				title='Meal One (8:00 - 9:00)'
				rows={[['3 - Whole Eggs', '2 - Turkey Bacon', '½ cup - Rice']]}
			/>
			<ItemGrid
				mt={true}
				title='Meal Two (12:00)'
				rows={[['6oz - Ground Beef', '1 cup - Green Beans', '½ cup - Rice']]}
			/>
			<p className='mt-5 px-3'>Snack</p>
			<p className='mt-3 px-3'>Chocolate Rice Cakes</p>
			<ItemGrid
				mt={true}
				title='Meal Three (16:00 - 17:00)'
				rows={[['4-oz - Chicken Breast', '1 cup - Green Beans', '½ cup - Rice']]}
			/>
			<p className='mt-5 px-3'>
				Carbohydrates provide 4 calories per gram, protein provides 4 calories per gram, and fat provides 9
				calories per gram.
			</p>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
